import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-user-workingdays-edit',
  templateUrl: './user-workingdays-edit.component.html',
  styleUrls: ['./user-workingdays-edit.component.css']
})
export class UserWorkingdaysEditComponent implements OnInit {

  constructor(private brandService: ServiceService, private router: Router, private route: ActivatedRoute) { }

  public model = Array()
  // public model = Array( new Date('7/15/1966'))
  minDate = new Date('1/1')
  maxDate = new Date('1/31')
  // calenderShown=false
  output: any = []; //---store get() result--------
  DName = "*"
  MName = "*"
  KpiId: any
  MonthName: any
  getdata: any = [];
  setData: any;
  array: any;
  Id = null

  data: any = {
    user_id: "",
    month_year: "",
    working_days: []
  }

  isShown: boolean = false;
  alert = ""
  message = ""
  department: any = [];
  parts = Array()

  Month = [{ name: "January", id: "01", last: 31 },
  { name: "February", id: "02", last: 28 },
  { name: "March", id: "03", last: 31 },
  { name: "April", id: "04", last: 30 },
  { name: "May", id: "05", last: 31 },
  { name: "June", id: "06", last: 30 },
  { name: "July", id: "07", last: 31 },
  { name: "August", id: "08", last: 31 },
  { name: "September", id: "09", last: 30 },
  { name: "October", id: "10", last: 31 },
  { name: "November", id: "11", last: 30 },
  { name: "December", id: "12", last: 31 },
  ]




  shown() {
    this.isShown = false
  }
  notification() {
    this.isShown = !this.isShown;
  }

  //---------function for edit brand detail-----
  btnClick() {
  
    this.data.working_days = this.model
    var Id=this.Id
    console.log("Data=", this.data)
    // --------api for put----------//
    this.brandService.updateUserWorkingDays(this.data).subscribe((res) => {
      console.log("res=", res)
      this.alert = res.message;
      this.router.navigate(['admin/user-working-days-view'],{queryParams:{setData:JSON.stringify({Id})}});

    })
  }

  //--------------function for date formating-----------------
  formatDate(dateStr: string): any {
    if (dateStr == null)
      return
    const [year, month] = dateStr.split('-');
    const date = new Date(`${year}-${month}-01`);

    const formattedDate = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
    return formattedDate;
  }

  SetModel(array: any) {
    console.log("array=", array)
    var temp_date_array = []
    for (var i = 0; i < array.length; i++) {

      temp_date_array.push(new Date(array[i]))

    }
    this.model = temp_date_array
  }
  ngOnInit(): void {


    //---call function in service for brand Id------
    this.route.queryParams.subscribe((params) => {
      this.getdata = params;
      this.setData = this.getdata.setData;
      const obj = JSON.parse(this.setData);
      this.array = [obj];
      this.Id = this.array[0].Id;
  
    })

    //-------api get()calling-------------
    this.brandService.viewUserWorkingDaysEach(this.Id).subscribe((res) => {
      this.output = res.data

      this.data.month_year = this.output.month_year
      this.MonthName = this.formatDate(this.data.month_year);

      this.parts = this.output.month_year.split('-');
      console.log("parts=", this.parts)
      const lastDay = new Date(this.parts[0], this.parts[1], 0);
      var numberOfDays = lastDay.getDate();
      this.data.user_id= this.output.user_id

      //---------set max and min for calender-------
      var start = this.parts[1] + "/" + "1" + "/" + this.parts[0]
      var end = this.parts[1] + "/" + numberOfDays + "/" + this.parts[0]
      console.log("start=", start)
      console.log("end=", end)
      this.minDate = new Date(start)
      this.maxDate = new Date(end)


      this.SetModel(this.output.working_days)

    })

  }

}
